import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HeaderSection from '../comp/HeaderSection';
import KPISection from './KPISection';
import PieChartSection from './PieChartSection';
import BalanceSection from '../comp/BalanceSection';
import ChartsSection from './ChartsSection';
import ChartsSection2 from './ChartsSection2';
import ModalReceitas from '../comp/ModalReceitas';

import { getResumoFinanceiro, getDatasEmAberto, getResumoContas, getTotaisReceitas, getGraficosReceitas, getAnyRoute } from '../../../api';

const PageContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* Adjust as needed for responsiveness */
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

const Receitas = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [datasEmAberto, setDatasEmAberto] = useState({});
  const [dateToOpen2, setDateToOpen2] = useState(null);
  const [contas, setContas] = useState({});
  const [totaisReceitas, setTotaisReceitas] = useState({})
  const [graficos, setGraficos] = useState({})
  const [metasVendas, setMetasVendas] = useState([]);

  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });

  useEffect(() => {
    fetchData();
  }, [filtro]);

  const fetchData = async () => {
    try {
      const result = await getResumoFinanceiro();
      const result2 = await getDatasEmAberto(filtro);
      const result3 = await getResumoContas();
      const result4 = await getTotaisReceitas(filtro);
      const result5 = await getGraficosReceitas(filtro)
      const result6 = await getAnyRoute('metasvendarecebimento', filtro);
      setData(result);
      setDatasEmAberto(result2);
      setContas(result3);
      setTotaisReceitas(result4)
      setGraficos(result5)
      setMetasVendas(result6)
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async () => {
    setDateToOpen2(null);
    const result = await getDatasEmAberto();
    setDatasEmAberto(result);
  };

  const onDoubleClick2 = (dateClicked) => {
    setDateToOpen2(dateClicked);
  };

  if (loading) {
    return <p>Carregando gráfico...</p>;
  }

  return (
    <PageContainer>
      <HeaderSection title={'Receitas'} setFiltro={setFiltro} filtro={filtro}/>
      <ChartsSection data={data} />
      <ChartsSection2 data={metasVendas} receivableDates={datasEmAberto.aReceber} onDoubleClick={onDoubleClick2} />

      <KPISection totaisReceitas={totaisReceitas} data={metasVendas} filtro={filtro}/>
      <PieChartSection graficos={graficos} />
      <BalanceSection data={contas} />
      {dateToOpen2 && <ModalReceitas dateToOpen={dateToOpen2} onClose={handleClose} />}
    </PageContainer>
  );
};

export default Receitas;
